function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
var PaymentsTemplate = require('./mixin-admin.template');
function formatReservationRemaining(ms) {
  var totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  var hours = Math.floor(totalSeconds / 3600);
  var minutes = Math.floor(totalSeconds % 3600 / 60);
  var seconds = totalSeconds % 60;
  if (hours > 0) {
    return "".concat(hours, "h ").concat(minutes, "m remaining");
  }
  if (minutes > 0) {
    return "".concat(minutes, "m ").concat(seconds, "s remaining");
  }
  return "".concat(seconds, "s remaining");
}
function parseModePair(value) {
  var _String$split = String(value || '').split(':'),
    _String$split2 = _slicedToArray(_String$split, 2),
    fulfillment_mode = _String$split2[0],
    payout_mode = _String$split2[1];
  return {
    fulfillment_mode: fulfillment_mode,
    payout_mode: payout_mode
  };
}
var MixinAdmin = /*#__PURE__*/function () {
  function MixinAdmin(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.admin-payments';
    _classCallCheck(this, MixinAdmin);
    this.app = app;
    // Browser Mixin instance that constructed this sidebar panel. Server-owned
    // payment configuration is loaded/saved through Admin get/update-admin-config,
    // not through this.mod.save() (browser options.mixin holds wallet credentials).
    this.mod = mod;
    this.container = container;
    this.transfers = [];
    this.account = undefined;
    this.error = '';
    this.loading = false;
    this.advancing = false;
    this.creating = false;
    this.restoring = false;
    this.restoreText = '';
    this.search = '';
    this.purpose = '';
    this.page = 1;
    this.total = 0;
    this.apiKeyConfigured = undefined;
    this.apiKeyText = '';
    this.savingApiKey = false;
    this.depositAddresses = [];
    this.fulfillment_mode = 'local';
    this.payout_mode = 'local';
    this.treasury_provider_publickeys = [];
    this.treasury_delegate_publickeys = [];
    this.treasury_provider_draft = '';
    this.treasury_delegate_draft = '';
    this.savingConfig = false;
    this.configNotice = '';
    this.tab = 'transfers';
    this.reservation_timer = null;
  }
  return _createClass(MixinAdmin, [{
    key: "admin",
    value: function admin() {
      return this.app.modules.returnModule('Admin');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$admin;
      this.transfers = [];
      this.account = undefined;
      this.error = '';
      this.loading = true;
      this.advancing = false;
      this.creating = false;
      this.restoring = false;
      this.restoreText = '';
      this.search = '';
      this.purpose = '';
      this.page = 1;
      this.total = 0;
      this.apiKeyConfigured = undefined;
      this.apiKeyText = '';
      this.savingApiKey = false;
      this.depositAddresses = [];
      this.fulfillment_mode = 'local';
      this.payout_mode = 'local';
      this.treasury_provider_publickeys = [];
      this.treasury_delegate_publickeys = [];
      this.treasury_provider_draft = '';
      this.treasury_delegate_draft = '';
      this.savingConfig = false;
      this.configNotice = '';
      this.tab = 'transfers';
      if (!((_this$admin = this.admin()) !== null && _this$admin !== void 0 && _this$admin.server_info)) {
        this.app.browser.replaceElementContentBySelector("<p class=\"admin-payments-empty\">Waiting for the server to finish authenticating this administrator.</p>", this.container);
        return;
      }
      this.refresh();
      this.load();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.stopReservationCountdown();
      this.app.browser.replaceElementContentBySelector(PaymentsTemplate({
        transfers: this.transfers,
        account: this.account,
        error: this.error,
        loading: this.loading,
        advancing: this.advancing,
        creating: this.creating,
        restoring: this.restoring,
        restoreText: this.restoreText,
        search: this.search,
        purpose: this.purpose,
        page: this.page,
        total: this.total,
        apiKeyConfigured: this.apiKeyConfigured,
        apiKeyText: this.apiKeyText,
        savingApiKey: this.savingApiKey,
        depositAddresses: this.depositAddresses,
        fulfillment_mode: this.fulfillment_mode,
        payout_mode: this.payout_mode,
        treasury_provider_publickeys: this.treasury_provider_publickeys,
        treasury_delegate_publickeys: this.treasury_delegate_publickeys,
        treasury_provider_draft: this.treasury_provider_draft,
        treasury_delegate_draft: this.treasury_delegate_draft,
        savingConfig: this.savingConfig,
        configNotice: this.configNotice,
        tab: this.tab
      }), this.container);
      this.attachEvents();
      this.startReservationCountdown();
    }
  }, {
    key: "stopReservationCountdown",
    value: function stopReservationCountdown() {
      if (this.reservation_timer) {
        clearInterval(this.reservation_timer);
        this.reservation_timer = null;
      }
    }
  }, {
    key: "updateReservationCountdowns",
    value: function updateReservationCountdowns() {
      var cells = document.querySelectorAll("".concat(this.container, " [data-reserved-until]"));
      if (!cells.length) {
        this.stopReservationCountdown();
        return;
      }
      var now = Date.now();
      cells.forEach(function (el) {
        var until = Number(el.getAttribute('data-reserved-until'));
        if (!Number.isFinite(until) || until <= 0) {
          el.textContent = 'Reserved';
          return;
        }
        var remaining = until - now;
        if (remaining <= 0) {
          el.textContent = 'Reserved';
          return;
        }
        el.textContent = "Reserved \xB7 ".concat(formatReservationRemaining(remaining));
      });
    }
  }, {
    key: "startReservationCountdown",
    value: function startReservationCountdown() {
      var _this = this;
      this.stopReservationCountdown();
      if (this.tab !== 'addresses') {
        return;
      }
      if (!document.querySelector("".concat(this.container, " [data-reserved-until]"))) {
        return;
      }
      this.updateReservationCountdowns();
      this.reservation_timer = setInterval(function () {
        return _this.updateReservationCountdowns();
      }, 1000);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      document.querySelectorAll('[data-payments-tab]').forEach(function (button) {
        button.onclick = function (e) {
          e.preventDefault();
          var next = button.getAttribute('data-payments-tab');
          if (!next || next === _this2.tab) {
            return;
          }
          _this2.tab = next;
          _this2.refresh();
        };
      });
      var refresh = document.getElementById('admin-payments-refresh');
      if (refresh) {
        refresh.onclick = function (e) {
          e.preventDefault();
          _this2.load();
        };
      }
      var apiKey = document.getElementById('admin-payments-api-key-submit');
      if (apiKey) {
        apiKey.onclick = function (e) {
          e.preventDefault();
          _this2.saveApiKey();
        };
      }
      var create = document.getElementById('admin-payments-create-account');
      if (create) {
        create.onclick = function (e) {
          e.preventDefault();
          _this2.createAccount();
        };
      }
      var restore = document.getElementById('admin-payments-restore-account-button');
      if (restore) {
        restore.onclick = function (e) {
          e.preventDefault();
          _this2.restoreAccount();
        };
      }
      var search = document.getElementById('admin-payments-search-form');
      if (search) {
        search.onsubmit = function (e) {
          var _document$getElementB, _document$getElementB2;
          e.preventDefault();
          var next = ((_document$getElementB = document.getElementById('admin-payments-search')) === null || _document$getElementB === void 0 || (_document$getElementB = _document$getElementB.value) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.trim()) || '';
          _this2.search = next;
          _this2.purpose = ((_document$getElementB2 = document.getElementById('admin-payments-purpose')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value) || '';
          _this2.page = 1;
          return _this2.load();
        };
      }
      var purpose = document.getElementById('admin-payments-purpose');
      if (purpose) {
        purpose.onchange = function () {
          _this2.purpose = purpose.value || '';
          _this2.page = 1;
          return _this2.load();
        };
      }
      document.querySelectorAll('[data-payments-page]').forEach(function (button) {
        button.onclick = function (e) {
          e.preventDefault();
          if (button.disabled) {
            return;
          }
          _this2.page = Number(button.getAttribute('data-payments-page'));
          _this2.load();
        };
      });
      document.querySelectorAll('[data-payment-action]').forEach(function (button) {
        button.onclick = function (e) {
          e.preventDefault();
          var action = button.getAttribute('data-payment-action');
          var id = button.getAttribute('data-payment-id');
          if (action === 'exclude-transfer') {
            var confirmed = confirm("Hide transfer ".concat(id, " from Pending Transfers? It will be left out of new automatic processing. A signed transaction that was already broadcast will still be reconciled."));
            if (!confirmed) {
              return;
            }
          }
          _this2.advance(id, action);
        };
      });
      var mode = document.getElementById('admin-payments-mode');
      if (mode) {
        mode.onchange = function () {
          var next = parseModePair(mode.value);
          _this2.fulfillment_mode = next.fulfillment_mode;
          _this2.payout_mode = next.payout_mode;
          _this2.configNotice = '';
          _this2.error = '';
          _this2.refresh();
        };
      }
      document.querySelectorAll('[data-payments-add-key]').forEach(function (button) {
        button.onclick = function (e) {
          e.preventDefault();
          _this2.addKey(button.getAttribute('data-payments-add-key'));
        };
      });
      document.querySelectorAll('[data-payments-remove-key]').forEach(function (button) {
        button.onclick = function (e) {
          e.preventDefault();
          _this2.removeKey(button.getAttribute('data-payments-remove-key'), button.getAttribute('data-payments-key'));
        };
      });
      var saveConfig = document.getElementById('admin-payments-mode-save');
      if (saveConfig) {
        saveConfig.onclick = function (e) {
          e.preventDefault();
          _this2.saveConfig();
        };
      }
    }
  }, {
    key: "sendAdminRequest",
    value: function () {
      var _sendAdminRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(request, data, callback) {
        var admin, tx;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              admin = this.admin();
              if (admin !== null && admin !== void 0 && admin.server_publickey) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(admin.server_publickey);
            case 2:
              tx = _context.v;
              tx.msg = _objectSpread({
                module: 'Admin',
                request: request
              }, data);
              _context.n = 3;
              return tx.sign();
            case 3:
              this.app.network.sendTransactionWithCallback(tx, function (res_tx) {
                return callback(res_tx.returnMessage());
              }, admin.server_publickey);
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function sendAdminRequest(_x, _x2, _x3) {
        return _sendAdminRequest.apply(this, arguments);
      }
      return sendAdminRequest;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.loading = true;
              this.error = '';
              this.refresh();
              _context2.n = 1;
              return this.sendAdminRequest('get-admin-config', {
                module_id: 'mixin',
                search: this.search,
                purpose: this.purpose,
                page: this.page
              }, function (res) {
                _this3.loading = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this3.error = res.err;
                  _this3.transfers = [];
                } else {
                  _this3.applyResult(res.result);
                }
                _this3.refresh();
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "applyResult",
    value: function applyResult(result) {
      this.transfers = (result === null || result === void 0 ? void 0 : result.transfers) || [];
      this.total = Number((result === null || result === void 0 ? void 0 : result.total) || 0);
      this.page = Number((result === null || result === void 0 ? void 0 : result.page) || this.page || 1);
      if ((result === null || result === void 0 ? void 0 : result.account) !== undefined) {
        this.account = result.account;
      }
      if (typeof (result === null || result === void 0 ? void 0 : result.api_key_configured) === 'boolean') {
        this.apiKeyConfigured = result.api_key_configured;
      }
      if (Array.isArray(result === null || result === void 0 ? void 0 : result.deposit_addresses)) {
        this.depositAddresses = result.deposit_addresses;
      }
      if ((result === null || result === void 0 ? void 0 : result.fulfillment_mode) !== undefined) {
        this.fulfillment_mode = result.fulfillment_mode;
      }
      if ((result === null || result === void 0 ? void 0 : result.payout_mode) !== undefined) {
        this.payout_mode = result.payout_mode;
      }
      if (Array.isArray(result === null || result === void 0 ? void 0 : result.treasury_provider_publickeys)) {
        this.treasury_provider_publickeys = _toConsumableArray(result.treasury_provider_publickeys);
      }
      if (Array.isArray(result === null || result === void 0 ? void 0 : result.treasury_delegate_publickeys)) {
        this.treasury_delegate_publickeys = _toConsumableArray(result.treasury_delegate_publickeys);
      }
    }
  }, {
    key: "addKey",
    value: function addKey(kind) {
      var _field$value;
      var field = document.getElementById("admin-payments-".concat(kind, "-key"));
      var value = (field === null || field === void 0 || (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.trim()) || '';
      if (!value) {
        this.error = 'Enter a Saito public key before adding it.';
        this.refresh();
        return;
      }
      if (!this.app.crypto.isPublicKey(value)) {
        this.error = 'That is not a valid Saito public key.';
        if (kind === 'provider') {
          this.treasury_provider_draft = value;
        } else {
          this.treasury_delegate_draft = value;
        }
        this.refresh();
        return;
      }
      var list = kind === 'provider' ? this.treasury_provider_publickeys : this.treasury_delegate_publickeys;
      if (list.includes(value)) {
        this.error = 'That public key is already configured.';
        this.refresh();
        return;
      }
      if (kind === 'delegate' && this.fulfillment_mode === 'treasury' && this.payout_mode === 'local' && list.length >= 1) {
        this.error = 'Treasury mode allows exactly one authorized delegate.';
        this.treasury_delegate_draft = value;
        this.refresh();
        return;
      }
      list.push(value);
      if (kind === 'provider') {
        this.treasury_provider_draft = '';
      } else {
        this.treasury_delegate_draft = '';
      }
      this.error = '';
      this.configNotice = '';
      this.refresh();
    }
  }, {
    key: "removeKey",
    value: function removeKey(kind, key) {
      if (kind === 'provider') {
        this.treasury_provider_publickeys = this.treasury_provider_publickeys.filter(function (entry) {
          return entry !== key;
        });
      } else {
        this.treasury_delegate_publickeys = this.treasury_delegate_publickeys.filter(function (entry) {
          return entry !== key;
        });
      }
      this.error = '';
      this.configNotice = '';
      this.refresh();
    }
  }, {
    key: "saveConfig",
    value: function () {
      var _saveConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this4 = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.savingConfig) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.savingConfig = true;
              this.error = '';
              this.configNotice = '';
              this.refresh();

              // Server-owned Mixin options are persisted by the server Mixin module's save()
              // through Admin update-admin-config. Browser this.mod.save() would write the
              // lite client's wallet credentials, not the payment server configuration.
              _context3.n = 2;
              return this.sendAdminRequest('update-admin-config', {
                module_id: 'mixin',
                data: {
                  action: 'save-config',
                  fulfillment_mode: this.fulfillment_mode,
                  payout_mode: this.payout_mode,
                  treasury_provider_publickeys: this.treasury_provider_publickeys,
                  treasury_delegate_publickeys: this.treasury_delegate_publickeys,
                  search: this.search,
                  purpose: this.purpose,
                  page: this.page
                }
              }, function (res) {
                _this4.savingConfig = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this4.error = res.err;
                  _this4.configNotice = '';
                  _this4.refresh();
                  return;
                }
                _this4.treasury_provider_draft = '';
                _this4.treasury_delegate_draft = '';
                _this4.applyResult(res.result);
                _this4.configNotice = 'Configuration saved.';
                _this4.refresh();
                if (typeof siteMessage === 'function') {
                  siteMessage('Configuration saved.', 3000);
                }
              });
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function saveConfig() {
        return _saveConfig.apply(this, arguments);
      }
      return saveConfig;
    }()
  }, {
    key: "saveApiKey",
    value: function () {
      var _saveApiKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this5 = this;
        var field;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              field = document.getElementById('admin-payments-api-key');
              this.apiKeyText = (field === null || field === void 0 ? void 0 : field.value) || '';
              if (this.apiKeyText.trim()) {
                _context4.n = 1;
                break;
              }
              this.error = 'Enter the Mixin API key JSON.';
              this.refresh();
              return _context4.a(2);
            case 1:
              this.savingApiKey = true;
              this.error = '';
              this.refresh();
              _context4.n = 2;
              return this.sendAdminRequest('update-admin-config', {
                module_id: 'mixin',
                data: {
                  action: 'save-api-key',
                  api_key: this.apiKeyText,
                  search: this.search,
                  purpose: this.purpose,
                  page: this.page
                }
              }, function (res) {
                _this5.savingApiKey = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this5.error = res.err;
                } else {
                  _this5.apiKeyText = '';
                  _this5.applyResult(res.result);
                }
                _this5.refresh();
              });
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function saveApiKey() {
        return _saveApiKey.apply(this, arguments);
      }
      return saveApiKey;
    }()
  }, {
    key: "restoreAccount",
    value: function () {
      var _restoreAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this6 = this;
        var field;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              field = document.getElementById('admin-payments-restore-account');
              this.restoreText = (field === null || field === void 0 ? void 0 : field.value) || '';
              if (this.restoreText.trim()) {
                _context5.n = 1;
                break;
              }
              this.error = 'Paste the Mixin account JSON to restore it.';
              this.refresh();
              return _context5.a(2);
            case 1:
              this.restoring = true;
              this.error = '';
              this.refresh();
              _context5.n = 2;
              return this.sendAdminRequest('update-admin-config', {
                module_id: 'mixin',
                data: {
                  action: 'restore-account',
                  account: this.restoreText,
                  search: this.search,
                  purpose: this.purpose,
                  page: this.page
                }
              }, function (res) {
                _this6.restoring = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this6.error = res.err;
                } else {
                  _this6.restoreText = '';
                  _this6.applyResult(res.result);
                }
                _this6.refresh();
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function restoreAccount() {
        return _restoreAccount.apply(this, arguments);
      }
      return restoreAccount;
    }()
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this7 = this;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              this.creating = true;
              this.error = '';
              this.refresh();
              _context6.n = 1;
              return this.sendAdminRequest('update-admin-config', {
                module_id: 'mixin',
                data: {
                  action: 'create-account',
                  search: this.search,
                  purpose: this.purpose,
                  page: this.page
                }
              }, function (res) {
                _this7.creating = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this7.error = res.err;
                } else {
                  _this7.applyResult(res.result);
                }
                _this7.refresh();
              });
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function createAccount() {
        return _createAccount.apply(this, arguments);
      }
      return createAccount;
    }()
  }, {
    key: "approveMigration",
    value: function () {
      var _approveMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(id) {
        var _this8 = this;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              return _context7.a(2, this.sendAdminRequest('update-admin-config', {
                module_id: 'mixin',
                data: {
                  id: id,
                  action: 'approve-migration',
                  search: this.search,
                  purpose: this.purpose,
                  page: this.page
                }
              }, function (res) {
                _this8.advancing = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this8.error = res.err;
                } else {
                  _this8.applyResult(res.result);
                }
                _this8.refresh();
              }));
          }
        }, _callee7, this);
      }));
      function approveMigration(_x4) {
        return _approveMigration.apply(this, arguments);
      }
      return approveMigration;
    }()
  }, {
    key: "verifyMigration",
    value: function () {
      var _verifyMigration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(id, amount, txHash) {
        var _this9 = this;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              return _context8.a(2, this.sendAdminRequest('update-admin-config', {
                module_id: 'mixin',
                data: {
                  id: id,
                  action: 'verify-migration',
                  amount: amount,
                  tx_hash: txHash,
                  search: this.search,
                  purpose: this.purpose,
                  page: this.page
                }
              }, function (res) {
                _this9.advancing = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this9.error = res.err;
                } else {
                  _this9.applyResult(res.result);
                }
                _this9.refresh();
              }));
          }
        }, _callee8, this);
      }));
      function verifyMigration(_x5, _x6, _x7) {
        return _verifyMigration.apply(this, arguments);
      }
      return verifyMigration;
    }()
  }, {
    key: "advance",
    value: function () {
      var _advance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(id, action) {
        var _this0 = this;
        var _document$querySelect, _document$querySelect2, amount, hash;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (!(action === 'approve-migration')) {
                _context9.n = 1;
                break;
              }
              this.advancing = true;
              this.error = '';
              this.refresh();
              return _context9.a(2, this.approveMigration(id));
            case 1:
              if (!(action === 'verify-migration')) {
                _context9.n = 2;
                break;
              }
              amount = ((_document$querySelect = document.querySelector("[data-migration-amount=\"".concat(id, "\"]"))) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value) || '';
              hash = ((_document$querySelect2 = document.querySelector("[data-migration-hash=\"".concat(id, "\"]"))) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value) || '';
              this.advancing = true;
              this.error = '';
              this.refresh();
              return _context9.a(2, this.verifyMigration(id, amount, hash));
            case 2:
              this.advancing = true;
              this.error = '';
              this.refresh();
              _context9.n = 3;
              return this.sendAdminRequest('update-admin-config', {
                module_id: 'mixin',
                data: {
                  id: id,
                  action: action,
                  search: this.search,
                  purpose: this.purpose,
                  page: this.page
                }
              }, function (res) {
                _this0.advancing = false;
                if (res !== null && res !== void 0 && res.err) {
                  _this0.error = res.err;
                } else {
                  _this0.applyResult(res.result);
                }
                _this0.refresh();
              });
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function advance(_x8, _x9) {
        return _advance.apply(this, arguments);
      }
      return advance;
    }()
  }]);
}();
module.exports = MixinAdmin;